import { render, staticRenderFns } from "./BaseFormSkeleton.vue?vue&type=template&id=ca9bb0e8"
import script from "./BaseFormSkeleton.vue?vue&type=script&lang=js"
export * from "./BaseFormSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports